export const HOLIDAYS_TABLE_HEAD = [
  'EMPLOYEES_HOLIDAY.LABEL.NAME',
  'EMPLOYEES_HOLIDAY.LABEL.DATE_OF_REQUEST',
  'EMPLOYEES_HOLIDAY.LABEL.STATUS',
  'EMPLOYEES_HOLIDAY.LABEL.TYPE',
  'EMPLOYEES_HOLIDAY.LABEL.DATE',
  'EMPLOYEES_HOLIDAY.LABEL.DETAILS',
];
